export default __webpack_public_path__ + "static/media/labyrinthen-tenancy-07.cf549fad.jpg";